import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserProfileService} from '../../../services/user.profile.service';
import {ToastrService} from 'ngx-toastr';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-user-access',
    templateUrl: './user-access.component.html',
    styleUrls: ['./user-access.component.scss'],
    providers: [UserProfileService],
    encapsulation: ViewEncapsulation.None
})
export class UserAccessComponent implements OnInit {

    @ViewChild('companyAccessTable') companyTable: any;
    @ViewChild('masterCustomerAccessTable') masterCustomerTable: any;

    public loading = false;
    public userFullName = 'User';
    private tableChoice = 'company';
    public profile: any = {};
    private companyRows: Array<any>;
    private masterCustomerRows: Array<any>;
    public canEditAccessToggle = true;

    private accessTypes: Array<object> = [
        { value: 2, text: 'Full'},
        { value: 1, text: 'Restricted'},
        { value: 0, text: 'No access'}
    ];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userProfileService: UserProfileService,
        private toastr: ToastrService,
        private title: Title
    ) {
        this.title.setTitle('User Profile');
    }

    ngOnInit() {
        this.loading = true;
        const userID = this.route.snapshot.params.id;
        this.userProfileService.getByUserId(userID).subscribe(data => {
            this.profile = data.profile;
            this.canEditAccessToggle = data.canEditAccessToggle;
            this.userFullName = data.userFullName;
            this.companyRows = data.access.company.map( row => {
                row.customers = row.customers.map( customer => {
                    customer['selected'] = customer['hasAccess'];
                    return customer;
                });

                row.vendors = row.vendors.map( vendor => {
                    vendor['selected'] = vendor['hasAccess'];
                    return vendor;
                });

                return row;
            });
            this.masterCustomerRows = data.access.masterCustomer.map( row => {
                row.customers = row.customers.map( customer => {
                    customer['selected'] = customer['hasAccess'];
                    return customer;
                });

                row.plants = row.plants.map( plant => {
                    plant['selected'] = plant['hasAccess'];
                    return plant;
                });

                return row;
            });
            this.loading = false;
        }, () => {
            this.loading = false;
            this.toastr.error('Request timed out', 'Service Error');
            this.onCancel();
        });
    }

    onCancel() {
        this.router.navigate(['user/profile/' + this.route.snapshot.params.id]);
    }

    save() {
        this.loading = true;
        this.profile['UP1_RESTRICT_DATA'] = this.profile['UP1_RESTRICT_DATA'] ? 1 : 0;
        this.profile['UP1_INCOGNITO_MODE'] = this.profile['UP1_INCOGNITO_MODE'] ? 1 : 0;

        const companyRowsToSubmit = this.companyRows.slice().map(companyRowItem => {
            delete companyRowItem.CO1_NAME;
            if (Number(companyRowItem.access) === 0 || Number(companyRowItem.access) === 2) {
                delete companyRowItem.customers;
                delete companyRowItem.vendors;
            } else {
                companyRowItem.customers = companyRowItem.customers.map(customerItem => {
                    delete customerItem.CU1_NAME;
                    delete customerItem.disabled;
                    return customerItem;
                });
                companyRowItem.vendors = companyRowItem.vendors.map(vendorItem => {
                    delete vendorItem.VD1_NAME;
                    delete vendorItem.disabled;
                    return vendorItem;
                });
            }
            return companyRowItem;
        });

        const masterCustomerRowsToSubmit = this.masterCustomerRows.slice().map(rowItem => {
            delete rowItem.CU0_NAME;
            if (Number(rowItem.access) === 0 || Number(rowItem.access) === 2) {
                delete rowItem.customers;
                delete rowItem.plants;
            } else {
                rowItem.customers = rowItem.customers.map(customerItem => {
                    delete customerItem.CU1_NAME;
                    delete customerItem.disabled;
                    return customerItem;
                });
                rowItem.plants = rowItem.plants.map(plantItem => {
                    delete plantItem.PL1_NAME;
                    delete plantItem.disabled;
                    return plantItem;
                });
            }
            return rowItem;
        });
        this.profile['access'] = JSON.stringify({company: companyRowsToSubmit, masterCustomer: masterCustomerRowsToSubmit});

        this.userProfileService.save( this.profile, true).subscribe(() => {
            this.router.navigate(['user/profile/' + this.route.snapshot.params.id]);
            this.loading = false;
        }, () => {
            this.toastr.error('Request timed out.', 'Service Error');
            this.loading = false;
        });
    }

    setTableChoice(tableChoice = 'company') {
        this.tableChoice = tableChoice;
    }

    changeAccess(row, table) {

        if (row.access === 0) {
            if ( row.extended ) {
                if ( table === 'company') {
                    this.companyTable.rowDetail.toggleExpandRow(row);
                } else if (table === 'masterCustomer') {
                    this.masterCustomerTable.rowDetail.toggleExpandRow(row);
                }
                row.extended = false;
            }
        } else if (row.access === 1) {
            if ( !row.extended ) {
                if ( table === 'company') {
                    this.companyTable.rowDetail.toggleExpandRow(row);
                } else if (table === 'masterCustomer') {
                    this.masterCustomerTable.rowDetail.toggleExpandRow(row);
                }
                row.extended = true;
            }
        } else if (row.access === 2) {
            if ( row.extended ) {
                if ( table === 'company') {
                    this.companyTable.rowDetail.toggleExpandRow(row);
                } else if (table === 'masterCustomer') {
                    this.masterCustomerTable.rowDetail.toggleExpandRow(row);
                }
                row.extended = false;
            }
        }

        this.prepareData(row, table, true);
    }

    toggleExpandCompanyRow(row) {
        row.extended = !row.extended;
        this.companyTable.rowDetail.toggleExpandRow(row);
    }

    toggleExpandMasterCustomerRow(row) {
        row.extended = !row.extended;
        this.masterCustomerTable.rowDetail.toggleExpandRow(row);
    }

    prepareData(row, table, updateAccess = false) {

        const rowAccess = Number(row.access);
        const disabled  = (rowAccess === 2 || rowAccess === 0);

        row.customers.forEach( item => {
            item.selected = rowAccess === 2 ? true : (rowAccess === 1 ? item.hasAccess : false);
            item.disabled = disabled;
        });

        if (table === 'company') {
            row.vendors.forEach( item => {
                item.selected = rowAccess === 2 ? true : (rowAccess === 1 ? item.hasAccess : false);
                item.disabled = disabled;
            });
        } else if (table === 'masterCustomer') {
            row.plants.forEach( item => {
                item.selected = rowAccess === 2 ? true : (rowAccess === 1 ? item.hasAccess : false);
                item.disabled = disabled;
            });
        }


        if (updateAccess) {
            for (const customerUpdated of row.customers) {
                if (table === 'company') {
                    // now update master customer
                    const masterCustomerIndex = this.masterCustomerRows.findIndex(
                        filterMasterCustomer => (
                            filterMasterCustomer.CU0_ID === customerUpdated.CU0_ID && Number(customerUpdated.CU0_ID) !== 0
                        )
                    );
                    if (masterCustomerIndex > -1) {
                        const customerIndex = this.masterCustomerRows[masterCustomerIndex].customers.findIndex(
                            filterCustomer => (
                                filterCustomer.CU1_ID === customerUpdated.CU1_ID && filterCustomer.CO1_ID === customerUpdated.CO1_ID
                            )
                        );
                        if (customerIndex > -1) {
                            this.masterCustomerRows[masterCustomerIndex].customers[customerIndex].selected = customerUpdated.hasAccess;
                            this.masterCustomerRows[masterCustomerIndex].customers[customerIndex].selected = customerUpdated.selected;
                            this.updateMasterCustomerAccess( masterCustomerIndex );
                        }
                    }
                } else if (table === 'masterCustomer') {
                    // now update company
                    const companyIndex = this.companyRows.findIndex(filterCompany => filterCompany.CO1_ID === customerUpdated.CO1_ID);
                    if (companyIndex > -1) {
                        const customerIndex = this.companyRows[companyIndex].customers.findIndex(
                            filterCustomer => filterCustomer.CU1_ID === customerUpdated.CU1_ID
                        );
                        if (customerIndex > -1) {
                            this.companyRows[companyIndex].customers[customerIndex].selected = customerUpdated.hasAccess;
                            this.companyRows[companyIndex].customers[customerIndex].selected = customerUpdated.selected;
                            this.updateCompanyAccess( companyIndex );
                        }
                    }
                }
            }
        }
    }

    private updateCompanyAccess( companyIndex ) {
        let restrictedAccess = false;
        let fullAccess = true;

        const customersSelected = [];
        for (const customerInArray of this.companyRows[companyIndex].customers) {
            if (customerInArray.selected) {
                customersSelected.push(customerInArray.CU1_NAME);
                restrictedAccess = true;
            } else {
                fullAccess = false;
            }
            if (restrictedAccess && !fullAccess) {
                break;
            }
        }
        for (const vendor of this.companyRows[companyIndex].vendors) {
            if (vendor.selected) {
                restrictedAccess = true;
            } else {
                fullAccess = false;
            }
            if (restrictedAccess && !fullAccess) {
                break;
            }
        }

        if (Number(this.companyRows[companyIndex].access) < 2) {
            this.companyRows[companyIndex].access = (fullAccess || restrictedAccess) ? 1 : 0;
        } else {
            this.companyRows[companyIndex].access = fullAccess ? 2 : (restrictedAccess ? 1 : 0);
        }
        this.companyRows[companyIndex].access = fullAccess ? 2 : (restrictedAccess ? 1 : 0);
    }

    private updateMasterCustomerAccess( masterCustomerIndex ) {
        let restrictedAccess = false;
        let fullAccess = true;

        const customersSelected = [];
        for (const customerInArray of this.masterCustomerRows[masterCustomerIndex].customers) {
            if (customerInArray.selected) {
                customersSelected.push(customerInArray.CU1_NAME);
                restrictedAccess = true;
            } else {
                fullAccess = false;
            }
            if (restrictedAccess && !fullAccess) {
                break;
            }
        }
        for (const plant of this.masterCustomerRows[masterCustomerIndex].plants) {
            if (plant.selected) {
                restrictedAccess = true;
            } else {
                fullAccess = false;
            }
            if (restrictedAccess && !fullAccess) {
                break;
            }
        }

        if (Number(this.masterCustomerRows[masterCustomerIndex].access) < 2) {
            this.masterCustomerRows[masterCustomerIndex].access = (fullAccess || restrictedAccess) ? 1 : 0;
        } else {
            this.masterCustomerRows[masterCustomerIndex].access = fullAccess ? 2 : (restrictedAccess ? 1 : 0);
        }
    }

    onCustomerChanged(event, customer, table) {
        customer.hasAccess = event.selected;
        customer.selected  = event.selected;

        const masterCustomerIndex = this.masterCustomerRows.findIndex(masterCustomer => (
            masterCustomer.CU0_ID === customer.CU0_ID && Number(customer.CU0_ID) !== 0
        ));
        const companyIndex = this.companyRows.findIndex(company => company.CO1_ID === customer.CO1_ID);
        if (table === 'company') {
            // update hasAccess & selected flag under master customer
            if (masterCustomerIndex > -1) {
                const customerIndex = this.masterCustomerRows[masterCustomerIndex].customers.findIndex(
                    filterCustomer => (filterCustomer.CU1_ID === customer.CU1_ID && filterCustomer.CO1_ID === customer.CO1_ID)
                );
                if (customerIndex > -1) {
                    // this.masterCustomerRows[masterCustomerIndex].customers[customerIndex].hasAccess = event.selected;
                    this.masterCustomerRows[masterCustomerIndex].customers[customerIndex].selected = event.selected;
                    this.updateMasterCustomerAccess( masterCustomerIndex );
                }
            }
            if (companyIndex > -1) {
                this.updateCompanyAccess( companyIndex );
            }
        } else {
            // update hasAccess & selected flag under company
            if (companyIndex > -1) {
                const customerIndex = this.companyRows[companyIndex].customers.findIndex(
                    filterCustomer => filterCustomer.CU1_ID === customer.CU1_ID
                );
                if (customerIndex > -1) {
                    // this.companyRows[companyIndex].customers[customerIndex].hasAccess = event.selected;
                    this.companyRows[companyIndex].customers[customerIndex].selected = event.selected;
                    this.updateCompanyAccess( companyIndex );
                }
            }
            if (masterCustomerIndex > -1) {
                this.updateMasterCustomerAccess( masterCustomerIndex );
            }
        }
    }

    onVendorChanged(event, vendor) {
        vendor.hasAccess = event.selected;
        vendor.selected  = event.selected;

        const companyIndex = this.companyRows.findIndex(company => company.CO1_ID === vendor.CO1_ID);
        if (companyIndex > -1) {
            this.updateCompanyAccess( companyIndex );
        }
    }

    onPlantChanged(event, plant) {
        plant.hasAccess = event.selected;
        plant.selected = event.selected;

        const masterCustomerIndex = this.masterCustomerRows.findIndex(masterCustomer => (
            masterCustomer.CU0_ID === plant.CU0_ID && Number(plant.CU0_ID) !== 0
        ));
        if (masterCustomerIndex > -1) {
            this.updateMasterCustomerAccess( masterCustomerIndex );
        }
    }

    onSelectAllPlants(row) {
        if (Number(row.access) === 1) {
            row.plants.forEach(plant => {
                plant.hasAccess = true;
                plant.selected = true;
            });
            const masterCustomerIndex = this.masterCustomerRows.findIndex(masterCustomer => (
                masterCustomer.CU0_ID === row.CU0_ID && Number(row.CU0_ID) !== 0
            ));
            if (masterCustomerIndex > -1) {
                this.updateMasterCustomerAccess( masterCustomerIndex );
            }
        }
    }

    getCellClass({ row, column, value }): any {
        return {
            'row-full-access': Number(row.access) === 2,
            'row-full-no-access': Number(row.access) === 0,
            'row-restricted-access': Number(row.access) === 1
        };
    }
}




// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/user-access/user-access.component.ts